export default {
      id: "menu__more-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__more",
      toString: function () {
        return this.url;
      }
    }